import styles from "./EmptyState.module.scss";
import SearchIcon from "@/assets/icons/SearchIcon";

type Props = {
  img?: any;
  title?: string;
  text?: string;
  className?: string;
  backgroundColor?: string;
};

const CustomEmptyState = ({ img, title, text, className = "", backgroundColor }: Props) => {
  return (
    <div
      className={`${styles.customEmptyState} ${className}`}
      style={{ background: backgroundColor }}
    >
      <div className={styles.customEmptyState__icon}>{img || <SearchIcon />}</div>
      {title && <h3 className={styles.customEmptyState__title}>{title}</h3>}
      {text && <p className={styles.customEmptyState__text}>{text}</p>}
    </div>
  );
};

export default CustomEmptyState;
